import script from "./AppSettingsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSettingsForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__